import React, { useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';

// Mock Data representing the portfolio items
const PORTFOLIO_DATA = [
  {
    id: 1,
    mainItem: {
      title: "KIMONO",
      image: "https://images.unsplash.com/photo-1519689680058-324335c77ebd?auto=format&fit=crop&q=80&w=800", // Replace with your baby in beige swaddle
      category: "OUR WORKS"
    },
    rightTopItem: {
      tag: "INDOOR",
      title: "Elisa & Family",
      image: "https://images.unsplash.com/photo-1544129476-7fea440de90b?auto=format&fit=crop&q=80&w=800" // Replace with woman holding baby with flowers
    },
    rightBottomItem: {
      tag: "INDOOR",
      title: "Zoyenna",
      image: "https://images.unsplash.com/photo-1555252333-9f8e92e65df9?auto=format&fit=crop&q=80&w=800" // Replace with baby in grey swaddle
    }
  },
  // You can add more objects here to enable the slider functionality
];

const PortfolioSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? PORTFOLIO_DATA.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === PORTFOLIO_DATA.length - 1 ? 0 : prev + 1));
  };

  const currentSet = PORTFOLIO_DATA[currentIndex];

  return (
    <div className="relative min-h-screen w-full bg-[#1c120c] text-white overflow-hidden font-sans select-none">
      {/* Background overlay texture/glow effect matching the warm moody tone */}
      <div className="absolute inset-0 bg-radial-gradient from-transparent to-[#0e0906] opacity-80 pointer-events-none" />

      <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 h-screen w-full">
        
        {/* --- LEFT SIDE: Main Feature (Kimono) --- */}
        <div className="relative h-1/2 md:h-full w-full overflow-hidden group">
          <img 
            src={currentSet.mainItem.image} 
            alt={currentSet.mainItem.title}
            className="w-full h-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-105"
          />
          {/* Dark overlay for text contrast */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/20" />
          
          {/* Vertical Title "KIMONO" */}
          <div className="absolute left-8 bottom-12 md:bottom-24 flex items-baseline gap-6 origin-left -rotate-90 translate-y-full">
            <span className="text-[10px] tracking-[0.3em] uppercase text-zinc-400 font-light whitespace-nowrap">
              {currentSet.mainItem.category}
            </span>
            <h1 className="text-6xl md:text-8xl font-serif tracking-wider font-medium text-amber-50/90 mix-blend-difference">
              {currentSet.mainItem.title}
            </h1>
          </div>

          {/* Left Navigation Arrow */}
          <button 
            onClick={handlePrev}
            className="absolute right-6 top-1/2 -translate-y-1/2 p-3 rounded-full bg-black/10 backdrop-blur-sm border border-white/10 hover:bg-white/20 transition-all duration-300 group/btn"
            aria-label="Previous slide"
          >
            <ArrowLeft className="w-6 h-6 text-white/80 group-hover/btn:-translate-x-1 transition-transform" />
          </button>
        </div>

        {/* --- RIGHT SIDE: Split Grid --- */}
        <div className="grid grid-rows-2 h-1/2 md:h-full w-full bg-[#160e0a]">
          
          {/* Top Right: Elisa & Family */}
          <div className="relative w-full h-full overflow-hidden group p-8 flex flex-col justify-end border-b border-white/5">
            <div className="absolute inset-0">
              <img 
                src={currentSet.rightTopItem.image} 
                alt={currentSet.rightTopItem.title}
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            </div>
            
            {/* Context Text */}
            <div className="relative z-10 max-w-xs">
              <span className="text-[10px] tracking-[0.2em] text-amber-500 font-semibold block mb-1">
                {currentSet.rightTopItem.tag}
              </span>
              <h2 className="text-2xl md:text-3xl font-serif text-zinc-100 font-light">
                {currentSet.rightTopItem.title}
              </h2>
            </div>
          </div>

          {/* Bottom Right: Zoyenna */}
          <div className="relative w-full h-full overflow-hidden group p-8 flex flex-col justify-end">
            <div className="absolute inset-0">
              <img 
                src={currentSet.rightBottomItem.image} 
                alt={currentSet.rightBottomItem.title}
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            </div>

            {/* Right Navigation Arrow */}
            <button 
              onClick={handleNext}
              className="absolute left-6 top-1/2 -translate-y-1/2 p-3 rounded-full bg-black/10 backdrop-blur-sm border border-white/10 hover:bg-white/20 transition-all duration-300 group/btn"
              aria-label="Next slide"
            >
              <ArrowRight className="w-6 h-6 text-white/80 group-hover/btn:translate-x-1 transition-transform" />
            </button>

            {/* Context Text */}
            <div className="relative z-10 max-w-xs ml-auto text-right md:text-left md:ml-0">
              <span className="text-[10px] tracking-[0.2em] text-amber-500 font-semibold block mb-1">
                {currentSet.rightBottomItem.tag}
              </span>
              <h2 className="text-2xl md:text-3xl font-serif text-zinc-100 font-light">
                {currentSet.rightBottomItem.title}
              </h2>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default PortfolioSlider;